import {
  GET_USERLIST_REQUEST,
  GET_USERLIST_SUCCESS,
  GET_USERLIST_FAIL,
  GET_USERUPDATE_REQUEST,
  GET_USERUPDATE_SUCCESS,
  GET_USERUPDATE_FAIL,
  GET_USERDEATILS_REQUEST,
  GET_USERDEATILS_SUCCESS,
  GET_USERDEATILS_FAIL,
  CONSULTANT_MESSAGE_REQUEST,
  CONSULTANT_MESSAGE_SUCCESS,
  CONSULTANT_MESSAGE_FAIL,
  CONSULTANT_NEW_MESSAGE,
  CONSULTANT_NEW_MESSAGE_CLIENT,
  CONSULTANT_NEW_MESSAGE_CLEAR,
  CONSULTANT_MSG_CLEAR_LENGTH,
} from './userConstant';

const initialState = {
  loading: false,
  activeUser: null,
  userList: [],
  updateuser: [],
  error: null,
  consultantChat: {},
};

export const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USERLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_USERLIST_SUCCESS:
      return {
        ...state,
        userList: payload,
        loading: false,
      };

    case GET_USERLIST_FAIL:
      return {
        ...state,
        loading: false,
        userList: [],
      };

    case GET_USERDEATILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_USERDEATILS_SUCCESS:
      return {
        ...state,
        activeUser: payload,
        loading: false,
      };
    case GET_USERDEATILS_FAIL:
      return {
        ...state,
        loading: false,
        userList: [],
      };
    case GET_USERUPDATE_REQUEST:
      return {
        ...state,
        // loading: true,
      };

    case GET_USERUPDATE_SUCCESS:
      return {
        ...state,
        // activeUser: payload,
        // updateuser: [],
      };
    case GET_USERUPDATE_FAIL:
      return {
        ...state,
        // loading: false,
        // activeUser: [],
        // updateuser: [],
      };
    case CONSULTANT_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CONSULTANT_MESSAGE_SUCCESS: {
      // console.log({ payload });
      return {
        ...state,
        loading: false,

        consultantChat: payload,
      };
    }
    case CONSULTANT_MESSAGE_FAIL:
      return {
        ...state,
        loading: false,

        consultantChat: {},
      };
    case CONSULTANT_NEW_MESSAGE: {
      // console.log('incomiing .....');
      const b = state?.userList.find((e) => e.user?._id == payload.userid);
      b?.chatmsg?.push(payload);
      const selectedId = localStorage.getItem('selectedId');

      if (selectedId != payload.userid && b) {
        b?.chatlength?.push(payload);
        // Remove the object from the array
        state.userList = state.userList.filter(
          (e) => e.user?._id !== payload.userid
        );

        // Add it back to the beginning of the array
        state.userList.unshift(b);
      }

      return {
        ...state,
      };
    }
    case CONSULTANT_NEW_MESSAGE_CLIENT: {
      const b = state.userList.find((e) => e?._id === payload.id);
      if (b) {
        b.chatmsg.push(payload.data);
      }
      console.log({ payload: b?.chatmsg });
      return {
        ...state,
      };
    }
    case CONSULTANT_NEW_MESSAGE_CLEAR: {
      const bs = state.userList.map((obj) => ({ ...obj, chatmsg: [] }));

      return {
        ...state,
        userList: bs,
      };
    }
    case CONSULTANT_MSG_CLEAR_LENGTH: {
      let b = state.userList?.find((e) => e?._id == payload);
      if (b) {
        b.chatlength = [];
      }
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
